import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_SUBSCRIPTIONS_FOR = createFcmConfig('enable_subscriptions_for', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
